<button [disabled]="!canResend" (click)="resend.emit(this.id)" ca-action-button>
  {{ "invite.resend" | translate }}
</button>
<button [disabled]="!canCancel" (click)="cancel.emit(this.id)" ca-action-button>
  {{ "invite.cancel" | translate }}
</button>
